import { MainLayout } from "../MainLayout";
import { Footer } from "../Footer";
import HomeMapSection from "../Home/HomeMapSection/HomeMapSection";
import { Introduction } from "../../Common/Introduction";
import { B2BAgents4 } from "../B2BAgents/B2BAgents4/B2BAgents4";
import MedicalTourism1 from "./MedicalTourism1/MedicalTourism1";
import MedicalTourism2 from "./MedicalTourism2/MedicalTourism2";
import MedicalTourism3 from "./MedicalTourism3/MedicalTourism3";
import MedicalTourism4 from "./MedicalTourism4/MedicalTourism4";
import MedicalTourism5 from "./MedicalTourism5/MedicalTourism5";
import { B2BAgents1 } from "../B2BAgents/B2BAgents1/B2BAgents1";
import MedicalTourism6 from "./MedicalTourism6/MedicalTourism6";

export const MedicalTourism = () => {
  const data = {
    title: "ABOUT MEDICAL TOURISM",
    head: "Connecting Global Healthcare with Seamless Travel",
    text: [
      "Established in 2013 in Djibouti, Blueberry Travel has built a strong reputation in global travel management, backed by over a decade of experience. Leveraging this expertise, Blueberry has expanded into medical tourism as a trusted facilitator, connecting international patients with accredited hospitals, renowned specialists, and world-class healthcare providers across leading medical destinations. We manage every aspect of the journey, from hospital selection and medical appointments to visa assistance, flights, accommodation, airport transfers, and personalized ground support ensuring a seamless, secure, and stress-free experience. By combining our expertise in travel management with dedicated patient coordination, Blueberry Group delivers reliable, end-to-end solutions for international medical travel.",
    ],
  };

   const data2 = [
        { id: 1, img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/medical/1.svg", title: "Seamless Global Care", desc: "Distance and language differences are never a barrier—we make your overseas treatment journey effortless and stress-free." },
        { id: 2, img: "/assets/kkkkk.png", title: "Personalized Treatment Guidance", desc: "We provide clear, personalized treatment options tailored to your medical needs, preferences, and budget." },
        { id: 3, img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/medical/3.svg", title: "Comfort Beyond Treatment", desc: "From accommodation and nutritious meals to local transportation, every aspect of your stay is thoughtfully arranged." },
        { id: 4, img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/medical/4.svg", title: "Language & Interpretation Support", desc: "Dedicated translators and multilingual coordinators ensure smooth communication throughout your medical journey." },
        { id: 5, img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/medical/5.svg", title: "Safe & Culturally Sensitive Care", desc: "We create a welcoming experience by respecting your cultural values, dietary preferences, and personal comfort." },
        { id: 6, img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/medical/6.svg", title: "Dedicated Patient Concierge", desc: "A dedicated care coordinator supports you at every stage—from your first inquiry to your safe return home." },

    ]
  return (
    <div>
      <MainLayout
        bgImage={
          'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/medical/medical.png")'
        }
        text1={"MEDICAL TOURISM"}
        text2={"Revolutionizing Global Healthcare Travel "}
        button={true}
      />
      {/* <Introduction data={data} /> */}
      <Introduction data={data} />
      <MedicalTourism1 />
      <MedicalTourism2 />
      <MedicalTourism3 />
      <MedicalTourism4 />
      <MedicalTourism5 />
      <B2BAgents1
        data={data2}
        // heading={"PARTNER WITH US"}
        desc={"Global Healthcare, Simplified"}
      />
      <MedicalTourism6/>
      <HomeMapSection />
      <B2BAgents4 showExpertise={false} showSupport={true} />
      <Footer />
    </div>
  );
};
